import React from 'react';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { Ionicons } from '@expo/vector-icons';
import HowToScreen from '../screens/HowToScreen';
import TrainingModeScreen from '../screens/TrainingModeScreen';
import GameNavigator from './GameNavigator';
import ProgressScreen from '../screens/ProgressScreen';
import { useAuth } from '../context/AuthContext';
import AccountMenu from '../components/AccountMenu';
import { colors } from '../styles/globalStyles';

const Tab = createBottomTabNavigator();

export default function TabNavigator() {
  const { user } = useAuth();

  return (
    <Tab.Navigator
      screenOptions={({ route }) => ({
        headerRight: () => <AccountMenu />,
        headerStyle: {
          backgroundColor: colors.surface,
        },
        headerTintColor: colors.primary,
        headerTitleStyle: {
          fontWeight: '700',
        },
        tabBarIcon: ({ focused, color, size }) => {
          let iconName;

          if (route.name === 'How To') {
            iconName = focused ? 'information-circle' : 'information-circle-outline';
          } else if (route.name === 'Training') {
            iconName = focused ? 'school' : 'school-outline';
          } else if (route.name === 'Games') {
            iconName = focused ? 'game-controller' : 'game-controller-outline';
          } else if (route.name === 'Progress') {
            iconName = focused ? 'analytics' : 'analytics-outline';
          }

          return <Ionicons name={iconName} size={size} color={color} />;
        },
        tabBarActiveTintColor: colors.primary,
        tabBarInactiveTintColor: 'gray',
      })}
    >
      <Tab.Screen 
        name="How To" 
        component={HowToScreen} 
        options={{ title: 'How To Play' }}
      />
      <Tab.Screen 
        name="Training" 
        component={TrainingModeScreen} 
        options={{ title: 'Training Mode' }}
      />
      <Tab.Screen 
        name="Games" 
        component={GameNavigator} 
        options={{ headerShown: false }}
      />
      {user?.id !== 'guest' && (
        <Tab.Screen 
          name="Progress" 
          component={ProgressScreen} 
          options={{ title: 'My Progress' }}
        />
      )}
    </Tab.Navigator>
  );
} 